import { defineComponent as _defineComponent } from 'vue'
import { MonitoringFilter, Options } from './types';
  import SearchButton from '@/components/common/SearchButton.vue';
  import LabelledInput from '@/components/common/LabelledInput.vue';
  import LabelledSelect from '@/components/common/LabelledSelect.vue';
  import { computed, onMounted, onUnmounted, ref } from 'vue';
  import { apiGetScreenGroups } from '@/api/screens';
  import { apiGetScreenPublishStatus } from '@/api/pulse';
  import { useToasted } from '@/helpers';
  import { PublishStatus } from '@/types/api/pulse';
  import BaseText from '@ui/atoms/baseText/BaseText.vue';
  import ProgressBar from '@/components/ProgressBar.vue';
  import { Colors } from '@/constant/theme';
  import ScreenRotationIcons from '@/components/common/screens/ScreenRotationIcons.vue';

  
  const __default__ = {
    name: 'PulseMonitoring',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

  const toasted = useToasted();
  const intervalId = ref<number | null>(null);
  const filter = ref<MonitoringFilter>({
    dateFrom: null,
    dateTo: null,
    group: null,
    status: null,
    search: '',
  });
  const isLoading = ref(false);
  const groupOptions = ref<Array<Options>>([
    {
      value: null,
      label: 'All Groups',
    },
  ]);
  const statusOptions = ref<Array<Options>>([
    {
      value: null,
      label: 'All Statuses',
    },
    {
      value: 'Pending',
      label: 'Pending',
    },
    {
      value: 'Updated',
      label: 'Updated',
    },
    {
      value: 'Failed',
      label: 'Failed',
    },
  ]);
  const publishInfo = ref<Array<PublishStatus>>([]);

  const filteredPublishInfo = computed(() => {
    return publishInfo.value.filter((publish: PublishStatus) => {
      let returnVal = true;

      if (filter.value.search) {
        returnVal =
          returnVal &&
          publish.screenName.toLowerCase().indexOf(filter.value.search.toLowerCase()) !== -1;
      }

      if (filter.value.group) {
        returnVal = returnVal && publish.screenGroup === filter.value.group;
      }

      if (filter.value.status) {
        returnVal = returnVal && publish.publishStatus === filter.value.status;
      }

      if (filter.value.dateFrom) {
        returnVal = returnVal && publish.publishDate > filter.value.dateFrom;
      }

      if (filter.value.dateTo) {
        returnVal = returnVal && publish.publishDate <= `${filter.value.dateTo}T23:59:59`;
      }

      return returnVal;
    });
  });

  const progressBarColor = computed(() => {
    if (!pendingPublishScreens.value.length) {
      return Colors.GREEN_LIGHT;
    }

    return Colors.PRIMARY_RED;
  });

  const pendingPublishScreens = computed(() => {
    return filteredPublishInfo.value.filter(
      (pub: PublishStatus) => pub.publishStatus === 'Pending' || !pub.publishStatus,
    );
  });
  const failedPublishScreens = computed(() => {
    return filteredPublishInfo.value.filter((pub: PublishStatus) => pub.publishStatus === 'Failed');
  });

  const uploadPercent = computed(() => {
    if (filteredPublishInfo.value.length === 0) {
      return 0;
    }

    return (
      ((filteredPublishInfo.value.length - pendingPublishScreens.value.length) * 100) /
      filteredPublishInfo.value.length
    );
  });

  onMounted(async () => {
    try {
      isLoading.value = true;
      const groups = await apiGetScreenGroups();
      groupOptions.value = [
        ...groupOptions.value,
        ...groups.map((group: any) => {
          return {
            label: group.name,
            value: group.name,
          };
        }),
      ];
    } catch (err) {
      console.log(err);
    }
    fetchScreenPublishStatus(true);
    intervalId.value = setInterval(() => {
      fetchScreenPublishStatus(false);
    }, 10000);
  });

  onUnmounted(() => {
    destroyTimer();
  });

  async function fetchScreenPublishStatus(showLoader: boolean = false) {
    isLoading.value = showLoader && true;
    try {
      const data = await apiGetScreenPublishStatus(undefined);
      publishInfo.value = data;
    } catch {
      toasted.global.general_error({
        message: 'Unable to load publish information',
      });
    }
    isLoading.value = false;
  }

  function isResultFiltered() {
    return Object.values(filter.value).some((x) => !!x);
  }

  function handleStatusFilterChange(value: string | number | null) {
    filter.value.status = value as string;
  }

  function handleGroupFilterChange(value: string | number | null) {
    filter.value.group = value as string;
  }

  function formatDate(date: string | null) {
    if (!date) return '';
    const dt = new Date(date);
    return dt
      .toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      })
      .toUpperCase();
  }

  function destroyTimer() {
    if (!intervalId.value) return;
    clearInterval(intervalId.value);
  }

  function isHorizontalScreen(screen: PublishStatus) {
    return !!screen?.orientation && ['180d', 'landscape'].includes(screen?.orientation);
  }

return { __sfc: true,toasted, intervalId, filter, isLoading, groupOptions, statusOptions, publishInfo, filteredPublishInfo, progressBarColor, pendingPublishScreens, failedPublishScreens, uploadPercent, fetchScreenPublishStatus, isResultFiltered, handleStatusFilterChange, handleGroupFilterChange, formatDate, destroyTimer, isHorizontalScreen, SearchButton, LabelledInput, LabelledSelect, BaseText, ProgressBar, ScreenRotationIcons }
}

})